import Model from "./model";

export default class CommunicationPreferences extends Model {
  public phone: boolean | null = null;
  public email: boolean | null = null;
}
